import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { MeScreen } from '../features/me/MeScreen'

/** E6 — Профиль. Защищённый роут. */
export const Route = createFileRoute('/me')({
  component: MeRoute,
})

function MeRoute() {
  return (
    <RequireAuth>
      <MeScreen />
    </RequireAuth>
  )
}
